import { render } from "./HeroiconsSolidExclamationCircle.vue?vue&type=template&id=f0ff31c8"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidExclamationCircle.vue"]])

export default __exports__